import { DocumentService } from '@dealstack/frontend/shared/dataExchange/services/document/document.service';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

export const useDownloadedFileBlobMutation = () => {
	const tCapManage = useTranslationCapManage();

	const downloadedFileBlob = async ({ fileId, dealId }: { fileId: string; dealId: string }) => {
		try {
			const data = await DocumentService.getDownloadPreSignedUrl({ dealId, fileId });
			const downloadUrl = data.payload?.downloadUrl;
			if (!downloadUrl) {
				throw new Error('Failed to get download URL');
			}
			const response = await fetch(downloadUrl);
			if (!response.ok) {
				throw new Error(`Failed to download file: ${response.statusText}`);
			}
			return {
				blob: await response.blob(),
				fileExtension: response.headers.get('fileextension'),
			};
		} catch (error) {
			showToastV2({
				title: tCapManage('documents.errors.download-document'),
				state: 'error',
			});
			throw error;
		}
	};

	return {
		downloadedFileBlob,
	};
};
